import React, { memo } from 'react';
import DeleteButton from './DeleteButton';
import { CanvasRef, DeleteButtonPosition } from '../types';

/**
 * 画布删除按钮容器组件
 * 
 * 统一管理边线和节点的删除按钮渲染
 */
interface CanvasDeleteButtonsProps {
  edgeDeleteBtnPos: DeleteButtonPosition | null;
  nodeDeleteBtnPos: DeleteButtonPosition | null;
  onEdgeDelete: () => void;
  onNodeDelete: () => void;
  canvasRef: CanvasRef;
}

const CanvasDeleteButtons: React.FC<CanvasDeleteButtonsProps> = memo(({
  edgeDeleteBtnPos,
  nodeDeleteBtnPos,
  onEdgeDelete,
  onNodeDelete,
  canvasRef,
}) => {
  return (
    <>
      {/* 节点删除按钮（右上角） */}
      {nodeDeleteBtnPos && (
        <DeleteButton
          position={nodeDeleteBtnPos}
          onClick={onNodeDelete}
          canvasRef={canvasRef}
        />
      )}
      
      {/* 边线删除按钮（中点） */}
      {edgeDeleteBtnPos && (
        <DeleteButton
          position={edgeDeleteBtnPos}
          onClick={onEdgeDelete}
          canvasRef={canvasRef}
        />
      )}
    </>
  );
});

CanvasDeleteButtons.displayName = 'CanvasDeleteButtons';

export default CanvasDeleteButtons;
